module.exports = __webpack_public_path__ + "img/appAsset--certificate-ax.b592f436.svg";